<div fxLayout="column" fxFlexFill *ngIf="!loader">

    <div class="divider layout-padd-2" ngClass.xs="layout-padd-5">
        <span class="mat-title">{{"cardComponent.title"|translate}}</span>
    </div>

    <div fxFlex class="scrolled layout-padd light-grey">

        <mat-card>
            <app-cards-backoffice-client [clientCards$]="clientCards$" [from]="'client'" (setClientCardsEvent)="setClientCards($event)">
            </app-cards-backoffice-client>
        </mat-card>

    </div>

</div>
<!--
<app-popup-loader [flagLoading]="loader" [size]="30" [statusMessage]="'cardComponent.loader'|translate">
</app-popup-loader>-->
